<template>
    <div v-loading="loading"
         element-loading-text="Loading"
         element-loading-spinner="el-icon-loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'height':((getHeight-80)+'px')}">
            <Side :step="'2'"></Side>
            <section style="overflow: hidden">
                <div style="color:#999;font-size:20px;font-weight:700;margin-bottom:5px;">Step 2</div>
                <div style="color:#333;font-size:24px;font-weight:700;margin-bottom:10px;">Choose Any Specialty That is Relevant to You</div>
                <div class="mt20 pageTitleDes" style="line-height: 30px;letter-spacing: 1px;">
                    eAssist has many career paths! Complete any assessment in the specialty for which you'd like to be considered - you do not need to take all assessments. Once submitted please allow our team up to 3 business days to review your application. After initiation of the interview process you may be invited to our Applicant Experience for the available opportunities you qualified.
                </div>
                <div style="width:100%;display: block">
                        <service-checkBox v-for="(item,index) in serviceList" :key="index" :info="item" @handleSelect="handleSelect"></service-checkBox>
                </div>
                <div style="margin-top: 20px">
                    <el-button @click="goHome">Back</el-button>
                    <el-button @click="nextStep" :class="{'yellowBtn':true,'grayBtn':disableNext}" :disabled="disableNext">{{nexBtnText}}</el-button>
                </div>
            </section>
        </div>
    </div>

</template>

<script>
    import ApplyHeader from "@/components/ApplyHeader";
    import Side from '@/components/Aside.vue'
    import ServiceCheckBox from "../../components/ServiceCheckBox";
    export default {
        name: "RelativePosition",
        components:{
            ApplyHeader,
            Side,
            ServiceCheckBox
        },
        computed:{
          getHeight(){
              return document.documentElement.clientHeight
          }
        },
        data(){
            return{
                loading:false,
                disableNext:true,
                selectItem:{},
                preBtnText:'< PRE',
                nexBtnText:'NEXT >',
                serviceList:[],
            }
        },
        created() {
            this.getServiceList()
        },
        methods:{
            getServiceList(){
                var email = localStorage.getItem('email')
                this.loading=true
                this.$axios.get(this.$URL.serviceUrl,{params:{email:email}}).then(res=>{
                    this.loading=false
                    if(res&&res.code==0){
                        var data = res.data
                        this.serviceList = data
                        // let applyPosition = localStorage.getItem('applyPosition')
                        //1.如果用户apply的时候选择的Dental Accounting，则只显示dental billing模块
                        //2.如果用户已完成了dental billing模块，则还能显示其他模块
                        let hasFinishWhatif = localStorage.getItem('whatIf')
                        // if(applyPosition==='Dental Accounting'&&hasFinishWhatif!='true'){
                        if(hasFinishWhatif!='true'){
                            this.serviceList = this.serviceList.filter(d=>{
                                this.$set(d,'checked',true)
                                return d.serviceName==='Dental Accounting'
                            })
                            this.selectItem=this.serviceList[0]
                            this.disableNext=false
                        }else{
                            this.serviceList.forEach((item)=>{
                                var storeService = this.$store.state.serviceInfo
                                if(storeService.serviceId==item.serviceId) {
                                    this.selectItem=item
                                    this.$set(item,'checked',true)
                                    this.disableNext=false
                                } else this.$set(item,'checked',false)
                            })
                        } 
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            nextStep(){
                if(this.selectItem.serviceId==undefined){
                    this.$message.error({message:'you must select the service!'})
                    return
                }
                // let applyPosition = localStorage.getItem('applyPosition')
                //跳转时把当前选中serviceId保存下来
                if(this.selectItem&&this.selectItem.serviceId)this.$store.commit('saveService',this.selectItem)
                if(this.selectItem.servicePath)this.$router.push({path:this.selectItem.servicePath})
                else if(this.selectItem.serviceName==='Dental Accounting')this.$router.push({path:'/dentalAccounting'})

            },
            goHome()
            {
                 this.$router.push({path:'/applicantHome'})
            },
            handleSelect(i){
                this.serviceList.forEach((item)=>{
                    if(item.serviceId==i){
                        this.disableNext=false
                        item.checked=true
                        this.selectItem=item
                    } else item.checked=false

                })
            }
        },
        watch:{
            '$route'(to,from){
                if(to.path==='/service'){
                    console.log(from)
                   this.getServiceList()
                }
            }
        }
    }
</script>

<style scoped>

</style>
